import 'dotenv/config';
import { registerAs } from '@nestjs/config';
import { MikroOrmModuleOptions } from '@mikro-orm/nestjs';
import { MySqlDriver, PopulateHint } from '@mikro-orm/mysql';
import { EntityGenerator } from '@mikro-orm/entity-generator';
import { TsMorphMetadataProvider } from '@mikro-orm/reflection';
import { SeedManager } from '@mikro-orm/seeder';
import { Migrator, TSMigrationGenerator } from '@mikro-orm/migrations';
import { SqlHighlighter } from '@mikro-orm/sql-highlighter';

const config: MikroOrmModuleOptions = {
  contextName: 'default',
  driver: MySqlDriver,
  host: process.env.DB_HOST,
  port: +process.env.DB_PORT!,
  user: process.env.DB_USERNAME,
  password: process.env.DB_PASSWORD,
  dbName: process.env.DB_DATABASE,
  debug: process.env.DB_DEBUG == 'true',
  verbose: true,
  strict: true,
  validate: true,
  forceUtcTimezone: true,
  autoJoinOneToOneOwner: false,
  autoJoinRefsForFilters: false,
  populateWhere: PopulateHint.INFER,
  highlighter: new SqlHighlighter(),
  metadataProvider: TsMorphMetadataProvider,
  extensions: [Migrator, EntityGenerator, SeedManager],
  entities: ['./dist/modules/**/*.entity.js'], // compiled JS
  entitiesTs: ['./src/modules/**/*.entity.ts'], // only for dev/CLI
  // entityRepository: ExtendedEntityRepository,
  filters: {
    softDelete: {
      cond: () => ({ deleted_at: null }),
      default: true,
    },
  },
  serialization: {
    forceObject: true,
  },
  schemaGenerator: {
    disableForeignKeys: true,
    createForeignKeyConstraints: true,
    ignoreSchema: [],
  },
  migrations: {
    path: './dist/database/migrations',
    pathTs: './src/database/migrations',
    glob: '!(*.d).{js,ts}',
    safe: true,
    generator: TSMigrationGenerator,
  },
  seeder: {
    path: './dist/database/seeders',
    pathTs: './src/database/seeders',
    defaultSeeder: 'DatabaseSeeder',
  },
};

export default config;

export const mikroOrmConfig = registerAs('database', () => config);
